import moment from "moment";
import { PencilSquare, ClipboardCheck } from "react-bootstrap-icons";

const ReviewRow = ({ label, value }) => (
  <div className="review-row">
    <span className="review-label">{label}</span>
    <span className="review-value">{value || "—"}</span>
  </div>
);

const ReviewCard = ({ title, onEdit, children }) => (
  <div className="review-card">
    <div className="review-card-header">
      <h5>{title}</h5>
      <button type="button" className="review-edit" onClick={onEdit}>
        <PencilSquare size={16} /> Edit
      </button>
    </div>
    <div className="review-card-body">{children}</div>
  </div>
);

const ReviewInformation = ({ data, onEditSection, isValidAccount }) => {
  return (
    <div className="review-wrapper text-start">
      {/* INFO BANNER */}
      <div className="review-banner">
        <ClipboardCheck size={20} />
        <div>
          <strong>Review Your Information</strong>
          <p>
            Please review all details below before submitting your VOM request.
          </p>
        </div>
      </div>

      {/* REQUESTOR DETAILS */}
      <ReviewCard title="Requestor Details" onEdit={() => onEditSection(0)}>
        <ReviewRow label="To (Lender)" value={data.to_name} />
        <ReviewRow label="From (Lender)" value={data.from_name} />
        <ReviewRow label="From Address" value={data.from_address} />
        <ReviewRow label="Title" value={data.lender_title} />
        <ReviewRow label="Lender's Number" value={data.lender_number} />
      </ReviewCard>

      {/* PROPERTY DETAILS */}
      <ReviewCard title="Property Details" onEdit={() => onEditSection(1)}>
        <ReviewRow
          label="Street Address"
          value={
            isValidAccount ? data?.masked_property_street : data.property_street
          }
        />
        <ReviewRow label="City" value={data.property_city} />
        <ReviewRow label="State" value={data.property_state} />
        <ReviewRow label="Zip Code" value={data.property_zip} />
        <ReviewRow label="Borrower Name" value={data.masked_applicant_name} />
        <ReviewRow label="Borrower Email" value={data.borrower_email} />
      </ReviewCard>

      {/* APPLICANT DETAILS */}
      <ReviewCard title="Applicant Information" onEdit={() => onEditSection(2)}>
        <ReviewRow label="Applicant Name" value={data.masked_applicant_name} />
        <ReviewRow
          label="Authorization Provided"
          value={data.borrower_signature ? "Yes" : "No"}
        />
      </ReviewCard>
    </div>
  );
};

export default ReviewInformation;

export const ReviewInformationForPayoff = ({
  data,
  onEditSection,
  isValidAccount,
}) => {
  return (
    <div className="review-wrapper text-start">
      {/* INFO BANNER */}
      <div className="review-banner">
        <ClipboardCheck size={20} />
        <div>
          <strong>Review Your Information</strong>
          <p>
            Please review all details below before submitting your payoff
            request.
          </p>
        </div>
      </div>

      {/* REQUESTOR DETAILS */}
      <ReviewCard title="Requestor Details" onEdit={() => onEditSection(0)}>
        <ReviewRow label="Requestor Name" value={data.requestor_name} />
        <ReviewRow label="Requestor Email" value={data.requestor_email} />
        <ReviewRow label="Requestor Type" value={data.requestor_type} />
        <ReviewRow label="Phone Number" value={data.phone_number} />
        <ReviewRow
          label="Payoff Good Through Date"
          value={moment(data.payoff_good_through_date).format("MM/DD/YYYY")}
        />
      </ReviewCard>

      {/* PROPERTY DETAILS */}
      <ReviewCard title="Property Details" onEdit={() => onEditSection(1)}>
        <ReviewRow
          label="Street Address"
          value={
            isValidAccount ? data?.masked_property_street : data.property_street
          }
        />
        <ReviewRow label="City" value={data.property_city} />
        <ReviewRow label="State" value={data.property_state} />
        <ReviewRow label="Zip Code" value={data.property_zip} />
        <ReviewRow label="Borrower Name" value={data.masked_applicant_name} />
        <ReviewRow label="Borrower Email" value={data.borrower_email} />
      </ReviewCard>

      {/* APPLICANT DETAILS */}
      <ReviewCard title="Payoff Information" onEdit={() => onEditSection(2)}>
        <ReviewRow
          label="Authorization Provided"
          value={data.borrower_signature ? "Yes" : "No"}
        />
      </ReviewCard>
    </div>
  );
};
